// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Keep document scrolling intact for feeds and existing page scroll handlers. */
.dark-app {
  min-height: 100dvh;
  padding-top: var(--ps-shell-top, 0px);
}

.dark-app > .top-nav {
  position: fixed;
  inset: 0 0 auto;
  width: 100%;
  padding-top: calc(.75rem + env(safe-area-inset-top));
  padding-left: max(1rem, env(safe-area-inset-left));
  padding-right: max(1rem, env(safe-area-inset-right));
}

.dark-app > .bottom-nav {
  position: fixed;
  inset: auto 0 0;
}

.dark-app > .dark-main-content {
  min-width: 0;
  padding-bottom: calc(var(--ps-shell-bottom, 0px) + 1rem);
}

.dark-app .top-nav-icons {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: .25rem;
}

.dark-app .top-nav-item {
  min-width: 0;
  width: 100%;
  padding-inline: .125rem;
}

.dark-app .bottom-nav-inner {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: .125rem;
  padding-inline: .5rem;
}

.dark-app .bottom-nav-item {
  min-width: 0;
  padding-inline: .125rem;
}

@media (max-width: 480px) {
  .dark-app .ps-shell-top-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: .5rem .75rem;
  }
  .dark-app .ps-shell-brand { grid-area: 1 / 1; }
  .dark-app .ps-shell-account-actions { grid-area: 1 / 2; justify-self: end; }
  .dark-app [data-testid="qualified-indicator"] { grid-area: 2 / 1; justify-self: start; padding-left: 0; }
  .dark-app [data-testid="golf-coins-btn"] { grid-area: 2 / 2; justify-self: end; max-width: 100%; }
}

/* Menus must still reach their last action on short screens. */
.ps-header-handicap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  height: 32px;
  min-width: 56px;
  padding: 0 4px;
  color: var(--ps-text-primary);
  transition: color 160ms ease;
}
.ps-header-handicap:hover { color: var(--ps-primary); }
.ps-header-handicap:focus-visible { outline: 2px solid var(--ps-primary); outline-offset: 3px; border-radius: 4px; }
.ps-header-handicap-value { font-size: 18px; font-weight: 750; line-height: 20px; font-variant-numeric: tabular-nums; }
.ps-header-handicap-label { font-size: 9px; line-height: 11px; color: var(--ps-text-secondary); }
.ps-home-animation-space { min-height: clamp(160px, 28svh, 260px); }

@media (max-width: 480px) {
  .dark-app .ps-shell-home-row { grid-template-columns: minmax(0, 1fr) 56px minmax(0, 1fr); column-gap: 4px; }
  .dark-app .ps-shell-home-row .ps-shell-brand { grid-area: 1 / 1 / 2 / 3; }
  .dark-app .ps-shell-home-row .ps-shell-account-actions { grid-area: 1 / 3; }
  .dark-app .ps-shell-home-row [data-testid="qualified-indicator"] { grid-area: 2 / 1; }
  .dark-app .ps-shell-home-row .ps-header-handicap { grid-area: 2 / 2; }
  .dark-app .ps-shell-home-row [data-testid="golf-coins-btn"] { grid-area: 2 / 3; }
}

/* Menus must still reach their last action on short screens. */
.dark-app .more-menu,
.dark-app [data-testid="notifications-dropdown"] {
  position: fixed;
  top: calc(var(--ps-shell-top, 0px) + .5rem);
  right: max(1rem, calc((100vw - 640px) / 2));
  max-width: calc(100vw - 2rem);
  margin-top: 0;
  max-height: calc(100dvh - var(--ps-shell-top, 0px) - var(--ps-shell-bottom, 0px) - 1rem);
  overflow-y: auto;
  overscroll-behavior-y: contain;
}`, "",{"version":3,"sources":["webpack://./src/styles/pinned-navigation.css"],"names":[],"mappings":"AAAA,gFAAgF;AAChF;EACE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,oDAAoD;EACpD,kDAAkD;EAClD,oDAAoD;AACtD;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE;IACE,aAAa;IACb,0CAA0C;IAC1C,iBAAiB;EACnB;EACA,4BAA4B,gBAAgB,EAAE;EAC9C,sCAAsC,gBAAgB,EAAE,iBAAiB,EAAE;EAC3E,gDAAgD,gBAAgB,EAAE,mBAAmB,EAAE,eAAe,EAAE;EACxG,2CAA2C,gBAAgB,EAAE,iBAAiB,EAAE,eAAe,EAAE;AACnG;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA,4BAA4B,wBAAwB,EAAE;AACtD,oCAAoC,oCAAoC,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AACnH,4BAA4B,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,kCAAkC,EAAE;AACtH,4BAA4B,cAAc,EAAE,iBAAiB,EAAE,+BAA+B,EAAE;AAChG,2BAA2B,sCAAsC,EAAE;;AAEnE;EACE,+BAA+B,yDAAyD,EAAE,eAAe,EAAE;EAC3G,+CAA+C,wBAAwB,EAAE;EACzE,yDAAyD,gBAAgB,EAAE;EAC3E,mEAAmE,gBAAgB,EAAE;EACrF,mDAAmD,gBAAgB,EAAE;EACrE,8DAA8D,gBAAgB,EAAE;AAClF;;AAEA,+DAA+D;AAC/D;;EAEE,eAAe;EACf,2CAA2C;EAC3C,2CAA2C;EAC3C,6BAA6B;EAC7B,aAAa;EACb,wFAAwF;EACxF,gBAAgB;EAChB,8BAA8B;AAChC","sourcesContent":["/* Keep document scrolling intact for feeds and existing page scroll handlers. */\n.dark-app {\n  min-height: 100dvh;\n  padding-top: var(--ps-shell-top, 0px);\n}\n\n.dark-app > .top-nav {\n  position: fixed;\n  inset: 0 0 auto;\n  width: 100%;\n  padding-top: calc(.75rem + env(safe-area-inset-top));\n  padding-left: max(1rem, env(safe-area-inset-left));\n  padding-right: max(1rem, env(safe-area-inset-right));\n}\n\n.dark-app > .bottom-nav {\n  position: fixed;\n  inset: auto 0 0;\n}\n\n.dark-app > .dark-main-content {\n  min-width: 0;\n  padding-bottom: calc(var(--ps-shell-bottom, 0px) + 1rem);\n}\n\n.dark-app .top-nav-icons {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: .25rem;\n}\n\n.dark-app .top-nav-item {\n  min-width: 0;\n  width: 100%;\n  padding-inline: .125rem;\n}\n\n.dark-app .bottom-nav-inner {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: .125rem;\n  padding-inline: .5rem;\n}\n\n.dark-app .bottom-nav-item {\n  min-width: 0;\n  padding-inline: .125rem;\n}\n\n@media (max-width: 480px) {\n  .dark-app .ps-shell-top-row {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    gap: .5rem .75rem;\n  }\n  .dark-app .ps-shell-brand { grid-area: 1 / 1; }\n  .dark-app .ps-shell-account-actions { grid-area: 1 / 2; justify-self: end; }\n  .dark-app [data-testid=\"qualified-indicator\"] { grid-area: 2 / 1; justify-self: start; padding-left: 0; }\n  .dark-app [data-testid=\"golf-coins-btn\"] { grid-area: 2 / 2; justify-self: end; max-width: 100%; }\n}\n\n/* Menus must still reach their last action on short screens. */\n.ps-header-handicap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  height: 32px;\n  min-width: 56px;\n  padding: 0 4px;\n  color: var(--ps-text-primary);\n  transition: color 160ms ease;\n}\n.ps-header-handicap:hover { color: var(--ps-primary); }\n.ps-header-handicap:focus-visible { outline: 2px solid var(--ps-primary); outline-offset: 3px; border-radius: 4px; }\n.ps-header-handicap-value { font-size: 18px; font-weight: 750; line-height: 20px; font-variant-numeric: tabular-nums; }\n.ps-header-handicap-label { font-size: 9px; line-height: 11px; color: var(--ps-text-secondary); }\n.ps-home-animation-space { min-height: clamp(160px, 28svh, 260px); }\n\n@media (max-width: 480px) {\n  .dark-app .ps-shell-home-row { grid-template-columns: minmax(0, 1fr) 56px minmax(0, 1fr); column-gap: 4px; }\n  .dark-app .ps-shell-home-row .ps-shell-brand { grid-area: 1 / 1 / 2 / 3; }\n  .dark-app .ps-shell-home-row .ps-shell-account-actions { grid-area: 1 / 3; }\n  .dark-app .ps-shell-home-row [data-testid=\"qualified-indicator\"] { grid-area: 2 / 1; }\n  .dark-app .ps-shell-home-row .ps-header-handicap { grid-area: 2 / 2; }\n  .dark-app .ps-shell-home-row [data-testid=\"golf-coins-btn\"] { grid-area: 2 / 3; }\n}\n\n/* Menus must still reach their last action on short screens. */\n.dark-app .more-menu,\n.dark-app [data-testid=\"notifications-dropdown\"] {\n  position: fixed;\n  top: calc(var(--ps-shell-top, 0px) + .5rem);\n  right: max(1rem, calc((100vw - 640px) / 2));\n  max-width: calc(100vw - 2rem);\n  margin-top: 0;\n  max-height: calc(100dvh - var(--ps-shell-top, 0px) - var(--ps-shell-bottom, 0px) - 1rem);\n  overflow-y: auto;\n  overscroll-behavior-y: contain;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
